import { ParsedQuery } from 'query-string';
import { Transformer } from 'hooks/use-hash';

type Show = ['show'];
type Invalid = ['invalid'];

export type DrawerParams = Show | Invalid;

export const NotificationsHash = 'notifications=show';

export const transformer: Transformer<DrawerParams> = {
  from: (parsed) => {
    if (typeof parsed.notifications !== 'string') {
      return ['invalid'];
    }

    return ['show'];
  },
  to: (params): ParsedQuery => {
    switch (params[0]) {
      case 'show':
        return {
          notifications: 'show',
        };
      default:
        return {
          notifications: null,
        };
    }
  },
};
